var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.273,
    height: 28,
    viewBox: "0 0 20.273 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45068",
    "data-name": "Path 45068",
    d: "M9.915,28a4.437,4.437,0,0,1-.647-.521A54.037,54.037,0,0,1,2.187,17.341,19.871,19.871,0,0,1,.226,12.188a9.777,9.777,0,0,1,1.181-7.17A9.879,9.879,0,0,1,7.257.436a9.836,9.836,0,0,1,6.755.351A10.183,10.183,0,0,1,20.225,9.15a10.929,10.929,0,0,1-.606,4.615,29.666,29.666,0,0,1-3.094,6.3,58.88,58.88,0,0,1-5.579,7.476,3.77,3.77,0,0,1-.593.459Zm.223-12.758a5.1,5.1,0,1,0-5.093-5.083,5.1,5.1,0,0,0,5.093,5.083",
    transform: "translate(0 0.001)",
    fill: "#ef7b13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOrange);
export default __webpack_public_path__ + "static/media/location_orange.a9c821d3206eafbe816d8329935e7757.svg";
export { ForwardRef as ReactComponent };